<template>
  <TheContainer>
    <TheFooter />
  </TheContainer>
</template>


<script>
//import TheHeader from "./components/TheHeader.vue";
import TheContainer from "./components/TheContainer.vue";
import TheFooter from "./components/TheFooter.vue";


export default {
  name: "App",
  components: {
    TheContainer,
    TheFooter
  },
  watch: {
    $route(to) {
      document.title = to.meta.title ;
    },
  },
};
</script>
<style>
@font-face {
  font-family: "VazirFarsiNumbers";
  src: local("VazirFarsiNumbers"), url(./fonts/vazir-fd.ttf) format("truetype");
  font-weight: 100;
}

.btn-theme {
  color: rgb(33, 40, 51);
  background-image: linear-gradient(
    rgb(248, 209, 47) 0%,
    rgb(240, 185, 11) 100%
  );
}

#app {
  font-family: "VazirFarsiNumbers", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #1b1b1b;
  margin-top: 0px;
  font-size: 80%;
}
</style>
